import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import CreateConfig from './CreateConfig';
import { Box, Chip, Switch } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomGridToolbar from '../../../../components/datagrid/GridToolBar';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAllConfig, updateStatus } from '../../../../redux/features/configSlice';
import { CONFIG_TYPES, CONFIG_WORKING_MODE } from '../../../../utils/constants/GlobalStaticData';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { getEmployeeTypes } from '../../../../redux/features/hrDashboard';
import { getAlldepartments } from '../../../../redux/features/generalSlice';

const Config = () => {
  const [gridSize, setGridSize] = useState(10);
  const { loading, configData } = useSelector((state) => state.config);
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const configColumns = [
    {
      field: 'config_id',
      headerName: 'ID',
      width: 20,
    },
    {
      field: 'config_name',
      headerName: 'Config Name',
      width: 300,
    },
    {
      field: 'config_status',
      headerName: 'Status',
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            color: params.row.config_status ? 'green' : 'red',
            fontWeight: 600,
          }}
        >
          {params.row.config_status ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      field: 'config_ref_id',
      headerName: 'Reference ID / Value',
      width: 180,
      renderCell: (params) => {
        let label = '—';
        if (params.value == 0) {
          label = 'All Users';
        } else if (params.row?.config_type == 5) {
          const ref = CONFIG_WORKING_MODE.find((item) => item.id == params.value);
          label = ref?.name || 'Unknown';
        }else if (params.row?.config_type == 6){
          label = `Value : ${params.value}`;
        }

        return <Chip color="primary" size="small" variant="outlined" label={label} />;
      },
    },

    {
      field: 'config_type',
      headerName: 'Config Type',
      width: 170,
      renderCell: (params) => {
        const type = CONFIG_TYPES.find((item) => item.id == params.value);
        return <Chip size="small" label={type.name || 'Not Available'} />;
      },
    },
    {
      field: 'Update',
      headerName: 'Update Status',
      width: 170,
      renderCell: (params) => (
        <Switch
          checked={params.row.config_status}
          onChange={() => {
            dispatch(updateStatus(params.row.config_id)).then((res) => {
              handleApiResponse(res, {
                onSuccess: () => {
                  dispatch(getAllConfig());
                },
                onFailed: () => {
                  console.log('Something went wrong');
                },
              });
            });
          }}
          slotProps={{ input: { 'aria-label': 'controlled' } }}
        />
      ),
    },
  ];
  useEffect(() => {
    dispatch(getAllConfig());
    dispatch(getAlldepartments());
  }, []);
  return (
    <GlobalWrapper actions={<CreateConfig />} title={'Config'}>
      <Box>
        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={configData}
          columns={configColumns}
          loading={loading}
          getRowId={(row) => row.config_id}
          pageSize={gridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Config;
